import { HubAdjustmentTaxInvoice } from '@/entity/HubAdjustmentTaxInvoice';
export default class HubAdjustmentTaxInvoiceVM extends HubAdjustmentTaxInvoice {
    // eslint-disable-next-line no-useless-constructor
    constructor(report) {
        super(report);
    }
}
